class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomImages: '[data-pswp-image]',
      btnXr: '[data-shopify-xr]'
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    const swiperOptions = JSON.parse(
      this.querySelector(this.selectors.slider).getAttribute(
        'data-swiper-options'
      )
    );

    if (Shopify.designMode) {
      this.addEventListener('shopify:section:load', event => {
        this.init();
      });
    }
    const withThumbs = this.dataset.withThumbs;

    if (withThumbs === 'true') {
      let setWrapperStyles = function (swiper) {
        let wrapperCenterClass = 'swiper-wrapper__center';
        let buttonDisabledClass = swiper.params.buttonDisabledClass;
        let wrapperEl = swiper.wrapper[0];

        if (
          swiper.prevButton[0].classList.contains(
            buttonDisabledClass
          ) &&
          swiper.nextButton[0].classList.contains(buttonDisabledClass)
        ) {
          // center slides
          wrapperEl.classList.add(wrapperCenterClass);
        } else {
          wrapperEl.classList.remove(wrapperCenterClass);
        }
      };
    }

    const totalSlides = this.querySelectorAll('.swiper-slide').length;
    const isSingleSlide = totalSlides <= 1;

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        initialSlide: 0,
        navigation: isSingleSlide
          ? false
          : {
              prevEl: this.querySelector('.swiper-button--prev'),
              nextEl: this.querySelector('.swiper-button--next')
            },

        pagination: isSingleSlide
          ? false
          : {
              el: '.swiper-pagination',
              type: 'progressbar'
            },

        spaceBetween: 2,
        watchOverflow: !isSingleSlide,
        allowTouchMove: !isSingleSlide,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        autoHeight: this.dataset.autoHeight === 'true',

        on: {
          afterInit: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              const firstSlide = swiper.slides[0];

              const firstSlideVideo =
                firstSlide.querySelector('video');

              if (firstSlideVideo) {
                this.playPromise(firstSlideVideo);
              }

              // if firstSlide has youtube, play it
              const firstSlideYoutube =
                firstSlide.querySelector('.js-youtube');
              if (firstSlideYoutube) {
                this.playYoutubeVideo(firstSlideYoutube);
              }

              // if firstSlide has vimeo, play it
              const firstSlideVimeo =
                firstSlide.querySelector('.js-vimeo');
              if (firstSlideVimeo) {
                this.playVimeoVideo(firstSlideVimeo);
              }
            }
          },

          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          slideChange: swiper => {
            if (window.innerWidth >= 990) {
              const activeIndex = swiper.activeIndex;
              const totalSlides = swiper.slides.length;
              const previousIndex = swiper.previousIndex;

              let isLastSlide = activeIndex === totalSlides - 1;
              let isArrivedLastSlide = false;

              const prevButton = document.querySelector(
                '.swiper-button.swiper-button--prev'
              );
              const swiperContainer = document.querySelector(
                '.product__media .swiper'
              );

              if (prevButton) {
                prevButton.addEventListener('click', () => {
                  isArrivedLastSlide = false;
                  swiperContainer.style.marginInlineStart = '0';
                });
              }

              if (swiperContainer) {
                swiperContainer.style.marginInlineStart = '0';
              }

              if (previousIndex > activeIndex) {
                isArrivedLastSlide = false;
                swiperContainer.style.marginInlineStart = '0';
              }
            }
          },
          transitionEnd: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              let slideIndex = swiper.activeIndex;

              const swiperCardWidth = swiper.slides[0].offsetWidth;

              slideIndex = Math.abs(
                Math.floor(swiper.translate / [swiperCardWidth])
              );

              const activeSlide = Array.from(swiper.slides).find(
                sliderSlide =>
                  sliderSlide.classList.contains(
                    'swiper-slide-active'
                  )
              );

              // play or pause videos in active and next slides
              const activeSlideVideo =
                activeSlide.querySelector('video');
              const nextSlideVideo =
                activeSlide.nextElementSibling?.querySelector(
                  'video'
                );

              const playVideo = video => {
                if (video && video.paused) {
                  this.playPromise(video);
                } else if (video) {
                  video.pause();
                }
              };

              playVideo(activeSlideVideo);
              playVideo(nextSlideVideo);

              const activeSlideYoutube =
                activeSlide.querySelector('.js-youtube');
              if (activeSlideYoutube) {
                this.playYoutubeVideo(activeSlideYoutube);
              }

              const activeSlideVimeo =
                activeSlide.querySelector('.js-vimeo');
              if (activeSlideVimeo) {
                this.playVimeoVideo(activeSlideVimeo);
              }
            }
          }
        }
      }
    };

    if (withThumbs === 'true') {
      const thumbSettings = {
        swiper: {
          el: '.swiper-thumbs',

          initialSlide: this.selectedMediaIndex,

          centeredSlides: true,
          centeredSlidesBounds: true,
          // slideToClickedSlide: true,
          freeMode: {
            enabled: true,
            sticky: true
          },
          direction: 'horizontal',

          slidesPerView: 6,
          spaceBetween: 2,

          threshold: 5,

          watchOverflow: !isSingleSlide,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          breakpoints: {
            750: {
              direction: swiperOptions.thumbsDirectionDesktop,
              spaceBetween: 5,
              slidesPerView: 5
            }
          },

          on: {
            touchEnd: function (s, e) {
              let range = 5;
              let diff = (s.touches.diff = s.isHorizontal()
                ? s.touches.currentX - s.touches.startX
                : s.touches.currentY - s.touches.startY);
              if (diff < range || diff > -range) s.allowClick = true;
            },
            afterInit: () => {
              this.querySelector('.swiper-thumbs').removeAttribute('style');
            }
          }
        }
      };

      this.settings.options.thumbs = thumbSettings;

      const slides = this.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      if (slideCount === 1) {
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 0.6,
            spaceBetween: 0
          }
        };
      } else {
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          1350: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          1920: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        };
      }

      // Add the thumbs-specific event handlers
      this.settings.options.on.init = swiper => {
        setTimeout(() => {
          swiper.thumbs.swiper.el.classList.add(
            'swiper-thumbs--visible'
          );
        }, 10);
      };

      this.settings.options.on.slideChangeTransitionStart =
        swiper => {
          const thumbsSwiper = swiper.thumbs.swiper;
          const activeIndex = swiper.activeIndex;
          const thumbsActiveIndex = thumbsSwiper.activeIndex;
          if (activeIndex !== thumbsActiveIndex) {
            thumbsSwiper.slideTo(activeIndex);
          }
        };
    } else {
      const slides = this.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      if (slideCount === 1) {
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 0.6,
            spaceBetween: 0
          }
        };
      } else {
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          1350: {
            slidesPerView: 1.3,
            spaceBetween: 0
          },
          1920: {
            slidesPerView: 1.7,
            spaceBetween: 0
          }
        };
      }
    }
  }

  playPromise(video) {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Automatic playback started!
          // Show playing UI.
          // video.play();
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          video.pause();
        });
    }
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage(
      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
      '*'
    );
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const [
      zoomContainerWidth,
      zoomContainerHeight,
      closeIcon,
      prevIcon,
      nextIcon
    ] = [
      this.offsetWidth,
      this.offsetHeight,
      this.querySelector('[data-close-icon]'),
      this.querySelector('[data-prev-icon]'),
      this.querySelector('[data-next-icon]')
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

    const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
      gallery: `#${this.settings.sliderElement.id}`,
      // appendToEl: this.querySelector(this.selectors.zoomContainer),
      children: 'a',
      mainClass: 'pswp--product-media-gallery',

      loop: true,
      showHideAnimationType: 'zoom',

      // A imagem abre inteira também no celular. Com vFill ela nascia mais
      // larga que a viewport, então o arrasto horizontal fazia pan dentro da
      // própria foto em vez de trocar de slide — o swipe só funcionava depois
      // de chegar na borda. O vFill vira o zoom do toque duplo.
      initialZoomLevel: zoomLevelObject => zoomLevelObject.fit,
      secondaryZoomLevel: zoomLevelObject => {
        if (isPhone()) {
          return zoomLevelObject.vFill;
        } else {
          return 1;
        }
      },
      pswpModule: PhotoSwipe
    });
    photoSwipeLightboxInstance.addFilter(
      'uiElement',
      (element, data) => {
        if (data.name === 'close') {
          element.innerHTML = closeIcon.innerHTML;
        } else if (data.name === 'arrowPrev') {
          element.innerHTML = prevIcon.innerHTML;
        } else if (data.name === 'arrowNext') {
          element.innerHTML = nextIcon.innerHTML;
        }
        return element;
      }
    );

    // html for video
    photoSwipeLightboxInstance.addFilter(
      'itemData',
      (itemData, index) => {
        if (itemData.type === 'html' && itemData.element) {
          return {
            html: itemData.element.dataset.pswpHtml
          };
        }
        return itemData;
      }
    );

    this.registerSidePreviews(photoSwipeLightboxInstance);
    this.bindGalleryHistory(photoSwipeLightboxInstance);

    photoSwipeLightboxInstance.init();

    this.bindSlideClickToGallery(photoSwipeLightboxInstance);

    photoSwipeLightboxInstance.on('beforeOpen', () => {
      const videos = this.querySelectorAll('video');
      Array.from(videos).forEach(video => {
        // if video is not playing, call playPromise
        // force to play
        video.play().then(() => {
            // Automatic playback started!
            // Show playing UI.
            // video.play();
          }).catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            video.pause();
          });

      });
    });

    // No celular, a página atrás do overlay continuava rolável e disputava o
    // gesto horizontal com o PhotoSwipe.
    photoSwipeLightboxInstance.on('afterInit', () => {
      if (isPhone()) {
        document.body.classList.add('overflow-hidden');
      }
    });

    photoSwipeLightboxInstance.on('destroy', () => {
      document.body.classList.remove('overflow-hidden');
    });

    this.addEventListener('dragstart', event => {
      event.preventDefault();
    });

    if (!this.settings.sliderElement) return;

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );
  }

  // Botão voltar do celular fecha a tela cheia em vez de sair da PDP.
  // Mesmo padrão do cart-drawer: uma entrada sentinela é empilhada na abertura
  // e desfeita no fechamento, quando este não veio do próprio popstate.
  bindGalleryHistory(lightbox) {
    let pushed = false;
    let skipHistoryBack = false;
    let onPopState = null;

    lightbox.on('afterInit', () => {
      if (pushed) return;

      try {
        history.pushState(
          { productGalleryOpen: true },
          '',
          location.href
        );
        pushed = true;
      } catch (error) {
        return;
      }

      onPopState = () => {
        // A entrada sentinela já saiu da pilha: fechar sem chamar back().
        skipHistoryBack = true;
        lightbox.pswp?.close();
      };

      window.addEventListener('popstate', onPopState);
    });

    lightbox.on('destroy', () => {
      if (!pushed) return;
      pushed = false;

      if (onPopState) {
        window.removeEventListener('popstate', onPopState);
        onPopState = null;
      }

      // Fechou pelo X, pelo Esc ou pelo arraste: desfaz a sentinela para não
      // sobrar uma entrada extra que exigiria dois toques em voltar.
      if (!skipHistoryBack) {
        try {
          history.back();
        } catch (error) {}
      }

      skipHistoryBack = false;
    });
  }

  // Prévias escurecidas da mídia anterior e da seguinte nas laterais da
  // galeria em tela cheia (desktop). Reaproveitam a imagem já carregada no
  // slider, então não geram requisição extra. Clicar navega para o slide.
  registerSidePreviews(lightbox) {
    const getSlideImage = index => {
      if (!this.settings.sliderElement) return null;
      const slide = this.settings.sliderElement.querySelector(
        `:scope > .swiper-wrapper > .swiper-slide[data-index="${index}"][data-media-type="image"]`
      );
      return slide ? slide.querySelector('img') : null;
    };

    lightbox.on('uiRegister', () => {
      const pswp = lightbox.pswp;

      // Publica o tamanho renderizado da imagem atual como custom properties,
      // para as prévias laterais nascerem exatamente do mesmo tamanho.
      const syncCurrentSize = () => {
        const slide = pswp.currSlide;
        if (!slide || !slide.width || !slide.height) return;

        const zoom =
          slide.zoomLevels?.initial || slide.currZoomLevel || 0;
        if (!zoom) return;

        pswp.element.style.setProperty(
          '--pswp-current-width',
          `${Math.round(slide.width * zoom)}px`
        );
        pswp.element.style.setProperty(
          '--pswp-current-height',
          `${Math.round(slide.height * zoom)}px`
        );
      };

      pswp.on('change', syncCurrentSize);
      pswp.on('resize', syncCurrentSize);
      pswp.on('openingAnimationEnd', syncCurrentSize);

      // Sentido do movimento, publicado como --pswp-swipe-offset na raiz: por
      // herança, prévias e imagem central entram pelo mesmo lado de onde o
      // conteúdo veio. Registrado antes das prévias para já estar atualizado
      // quando elas reagirem ao mesmo evento 'change'.
      let direction = 1;
      let lastIndex = null;

      pswp.on('change', () => {
        const total = pswp.getNumItems();

        if (lastIndex !== null && total > 1) {
          let delta = pswp.currIndex - lastIndex;

          // Normaliza o salto do loop: última -> primeira ainda é avanço.
          if (delta > total / 2) delta -= total;
          if (delta < total / -2) delta += total;

          if (delta !== 0) direction = delta > 0 ? 1 : -1;
        }

        lastIndex = pswp.currIndex;

        pswp.element.style.setProperty(
          '--pswp-swipe-offset',
          direction > 0 ? '6rem' : '-6rem'
        );
      });

      // Entrada da imagem central. O PhotoSwipe aplica zoom/pan no
      // .pswp__zoom-wrap, então transform e opacity da <img> estão livres.
      // Só depois da abertura, para não competir com a animação de zoom.
      let hasOpened = false;

      pswp.on('openingAnimationEnd', () => {
        hasOpened = true;
      });

      pswp.on('slideActivate', event => {
        if (!hasOpened) return;

        const image = event.slide?.content?.element;
        if (!image || image.tagName !== 'IMG') return;

        image.classList.remove('pswp__img--enter');
        // Reflow force o reinício da animação em trocas consecutivas.
        void image.offsetWidth;
        image.classList.add('pswp__img--enter');
      });

      ['prev', 'next'].forEach(direction => {
        pswp.ui.registerElement({
          name: `sidePreview-${direction}`,
          order: 20,
          isButton: false,
          appendTo: 'wrapper',
          html: '<img alt="" aria-hidden="true">',
          onInit: element => {
            element.classList.add(
              'pswp__side-preview',
              `pswp__side-preview--${direction}`
            );

            const previewImage = element.querySelector('img');

            const update = () => {
              const total = pswp.getNumItems();
              const step = direction === 'prev' ? -1 : 1;
              const index = pswp.currIndex + step;

              // A navegação circula (loop), mas a prévia não: nas pontas o
              // lado sem vizinho real fica vazio.
              if (index < 0 || index > total - 1) {
                element.style.display = 'none';
                return;
              }

              const sourceImage = getSlideImage(index);

              if (!sourceImage) {
                element.style.display = 'none';
                return;
              }

              const nextSrc =
                sourceImage.currentSrc || sourceImage.src;

              element.style.display = '';

              if (previewImage.getAttribute('src') === nextSrc) return;

              // Troca com swipe: a nova imagem entra deslizando pelo lado de
              // onde o conteúdo veio. O primeiro frame aplica o estado inicial
              // da transição, o segundo devolve ao normal e a anima.
              element.classList.add('is-updating');
              previewImage.src = nextSrc;

              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  element.classList.remove('is-updating');
                });
              });
            };

            element.addEventListener('click', () => {
              if (direction === 'prev') {
                pswp.prev();
              } else {
                pswp.next();
              }
            });

            pswp.on('change', update);
            update();
          }
        });
      });
    });
  }

  // Abre a galeria em tela cheia ao clicar em qualquer ponto da imagem,
  // não só no botão de expandir. Ignora o clique quando o usuário arrastou
  // o slider (swipe/drag) e quando o alvo já é um controle próprio.
  bindSlideClickToGallery(lightbox) {
    if (!this.settings.sliderElement) return;

    const slides = this.settings.sliderElement.querySelectorAll(
      ':scope > .swiper-wrapper > .swiper-slide[data-media-type="image"]'
    );

    slides.forEach(slide => {
      let startX = 0;
      let startY = 0;
      let dragged = false;

      slide.addEventListener('pointerdown', event => {
        startX = event.clientX;
        startY = event.clientY;
        dragged = false;
      });

      slide.addEventListener('pointermove', event => {
        if (
          Math.abs(event.clientX - startX) > 8 ||
          Math.abs(event.clientY - startY) > 8
        ) {
          dragged = true;
        }
      });

      slide.addEventListener('click', event => {
        if (dragged) return;
        if (event.target.closest('a, button')) return;

        event.preventDefault();
        lightbox.loadAndOpen(Number(slide.dataset.index) || 0);
      });
    });
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem)
    ).find(media => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.sliderInstance.slideTo(
      Number(mediaFound.dataset.index)
    );
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');
    const isModel = activeSlide.dataset.mediaType === 'model';
    if (!isModel) return;
    const btnXr = this.querySelector(this.selectors.btnXr);
    btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);
